import React, { useRef, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logoutUser } from '@store/reducers/auth';
import { getInfomationAccountFromToken } from '../../../../utils/helper';

const UserDropdown = () => {
    const dropdownRef = useRef(null);
    const history = useHistory();
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const account = getInfomationAccountFromToken();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleClickOutside = (event) => {
        if (
            dropdownRef &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setIsDropdownOpen(false);
        }
    };

    const logOut = (event) => {
        setIsDropdownOpen(false);
        event.preventDefault();
        dispatch(logoutUser());
        history.push('/login');
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside, false);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, false);
        };
    });

    return (
        <li 
            ref={dropdownRef} 
            className={`nav-item dropdown user-menu ${isDropdownOpen ? 'show' : ''}`}
            style={{ listStyle: 'none' }}
        >
            {/* Toggle Button */}
            <button
                onClick={toggleDropdown}
                type="button"
                className="nav-link dropdown-toggle d-flex align-items-center"
                style={{ 
                    border: 'none', 
                    background: 'transparent', 
                    outline: 'none',
                    padding: '8px 12px',
                    cursor: 'pointer'
                }}
            >
                <img
                    src="/img/default-profile.png"
                    className="user-image img-circle"
                    alt="User"
                    style={{
                        height: '34px',
                        width: '34px',
                        borderRadius: '50%',
                        border: '2px solid rgba(255,255,255,0.4)',
                        transition: 'border-color 0.3s'
                    }}
                />
                <i className="fas fa-caret-down ml-2 text-white-50" style={{ fontSize: '12px' }} />
            </button>

            {/* Modern Dropdown Card Menu */}
            <div 
                className={`dropdown-menu dropdown-menu-right ${isDropdownOpen ? 'show' : ''}`}
                style={{
                    position: 'absolute',
                    right: 0,
                    left: 'auto',
                    top: '100%',
                    width: '260px',
                    backgroundColor: '#ffffff',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
                    padding: '0',
                    margin: '8px 0 0 0',
                    overflow: 'hidden',
                    display: isDropdownOpen ? 'block' : 'none',
                    zIndex: 1050
                }}
            >
                {/* User Compact Info Header */}
                <div 
                    style={{
                        padding: '18px',
                        backgroundColor: '#f8f9fa',
                        borderBottom: '1px solid #ebeef0',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center'
                    }}
                >
                    <img
                        src="/img/default-profile.png"
                        alt="User profile"
                        style={{
                            height: '56px',
                            width: '56px',
                            borderRadius: '50%',
                            border: '3px solid #ffffff',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                            marginBottom: '10px'
                        }}
                    />
                    <h6 
                        style={{ 
                            margin: '0 0 4px 0', 
                            fontWeight: '700', 
                            color: '#2c3e50',
                            fontSize: '14.5px',
                            wordBreak: 'break-all'
                        }}
                    >
                        {account?.email || account?.username || 'Tài khoản'}
                    </h6>
                    <span 
                        style={{ 
                            fontSize: '11px', 
                            fontWeight: '600', 
                            color: '#1f6f39', 
                            backgroundColor: '#eaf4ee', 
                            padding: '3px 10px', 
                            borderRadius: '20px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                    >
                        {account?.role || 'Người dùng'}
                    </span>
                </div>

                {/* Dropdown Action Links */}
                <div style={{ padding: '8px 0' }}>
                    {/* <Link 
                        to="/nhan-vien" 
                        className="dropdown-item d-flex align-items-center"
                        onClick={() => setIsDropdownOpen(false)}
                        style={{
                            padding: '10px 18px',
                            fontSize: '13.5px',
                            color: '#4f5d75',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                            gap: '12px',
                            textDecoration: 'none'
                        }}
                    >
                        <i className="fas fa-user-edit" style={{ color: '#1f6f39', fontSize: '14px', width: '16px' }} />
                        Khai báo nhân viên
                    </Link> */}

                    <Link 
                        to="/profile-cv" 
                        className="dropdown-item d-flex align-items-center"
                        onClick={() => setIsDropdownOpen(false)}
                        style={{
                            padding: '10px 18px',
                            fontSize: '13.5px',
                            color: '#4f5d75',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                            gap: '12px',
                            textDecoration: 'none'
                        }}
                    >
                        <i className="fas fa-university" style={{ color: '#1f6f39', fontSize: '14px', width: '16px' }} />
                        Danh sách giảng viên
                    </Link>

                    <Link 
                        to="/profile" 
                        className="dropdown-item d-flex align-items-center"
                        onClick={() => setIsDropdownOpen(false)}
                        style={{
                            padding: '10px 18px',
                            fontSize: '13.5px',
                            color: '#4f5d75',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                            gap: '12px',
                            textDecoration: 'none'
                        }}
                    >
                        <i className="fas fa-key" style={{ color: '#1f6f39', fontSize: '14px', width: '16px' }} />
                        Đổi mật khẩu
                    </Link>

                    <div style={{ height: '1px', backgroundColor: '#ebeef0', margin: '6px 0' }} />

                    <button
                        type="button"
                        className="dropdown-item d-flex align-items-center w-100"
                        onClick={logOut}
                        style={{
                            padding: '10px 18px',
                            fontSize: '13.5px',
                            color: '#d9534f',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                            gap: '12px',
                            border: 'none',
                            background: 'transparent',
                            textAlign: 'left',
                            cursor: 'pointer'
                        }}
                    >
                        <i className="fas fa-sign-out-alt" style={{ color: '#d9534f', fontSize: '14px', width: '16px' }} />
                        {t('login.button.signOut')}
                    </button>
                </div>
            </div>
        </li>
    );
};

export default UserDropdown;
